<template>
  <div class="rechargeResult">
    <div class="result">
      <div class="result_box" :class="{'mb32': result===2}">
        <img class="result_icon" src="../assets/images/recharge/pay_success.png" alt="" v-if="result===1">
        <img class="result_icon" src="../assets/images/recharge/pay_fail.png" alt="" v-else>
        <span class="result_tips" :class="{'active': result===2}">{{result===1?'支付成功':'支付失败'}}</span>
      </div>
      <p class="actual" v-if="result===1">实付：￥{{price}}</p>
      <p class="deduction" v-if="result===1&&(integral>0||balance>0)">{{integral>0?`抵扣 ${integral}积分`:''}}{{integral>0&&balance>0?' + ':''}}{{balance>0?`账户余额${balance}元`:''}}</p>
      <div class="btns" v-if="result===1">
        <div class="btn" @click="toHome">返回首页</div>
        <div class="btn yellow" v-if="is_live===1" @click="toLive">查看讲座回放</div>
        <div class="btn" v-else @click="toMyOrder">查看订单</div>
      </div>
      <div class="btns" v-else>
        <div class="btn active" @click="toMyOrder">重新支付</div>
      </div>
    </div>
    <div class="wrap">
      <guess-like :id="id"></guess-like>
    </div>
  </div>
</template>

<script>
import guessLike from '@/components/guessLike'
export default {
  name: 'success',
  components: {
    guessLike
  },
  data () {
    return {
      result: 1,
      charge_name: '',
      price: '', // 实付金额
      is_live: 0, // 1为讲座
      id: '', // 讲座所需id
      lecture_id: '', // 讲座所需lecture_id
      integral: '', // 抵扣的积分
      balance: '' // 扣除的余额
    }
  },
  created () {
    this.id = this.$route.query.id
  },
  mounted () {
    this.result = this.$route.query.result
    this.charge_name = this.$route.query.name
    this.price = this.$route.query.price
    this.is_live = this.$route.query.is_live
    this.id = this.$route.query.id
    this.lecture_id = this.$route.query.lecture_id
    this.integral = this.$route.query.integral
    this.balance = this.$route.query.balance
  },
  methods: {
    toHome () {
      this.$router.push({
        path: '/'
      })
    },
    toMyOrder () {
      this.$router.push({
        name: 'myOrder'
      })
    },
    toLive () {
      this.$router.push({
        name: 'live',
        query: {
          id: this.id, // 业务id
          lecture_id: this.lecture_id // 直播id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.rechargeResult{
  font-family: PingFang HK, PingFang HK-Regular;
}
.result{
  min-height: 256px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  padding: 48px 0 32px;
  .result_box{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    &.mb32{
      margin-bottom: 32px;
    }
    .result_icon{
      width: 64px;
      height: 64px;
      display: block;
      margin-right: 8px;
    }
    .result_tips{
      color: #13AC7E;
      font-weight: bold;
      font-size: 32px;
      &.active{
        color: #e40505;
      }
    }
  }
  .btns{
    display: flex;
    .btn{
      width: 176px;
      height: 64px;
      background: #ffffff;
      border: 2px solid #cecece;
      border-radius: 8px;
      text-align: center;
      line-height: 64px;
      color: #2b2b2b;
      font-size: 28px;
      &.long{
        width: 208px;
      }
      &.active{
        background: #027cdf;
        border: 2px solid #027cdf;
        color: #ffffff;
      }
      &.yellow{
        width: 208px;
        background: #ffbb00;
        border: 2px solid #ffbb00;
        color: #2b2b2b;
      }
    }
    .btn+.btn{
      margin-left: 40px;
    }
  }
}
.wrap{
  padding: 0 24px;
}
.actual{
  font-size: 32px;
  color: #e40505;
  margin-bottom: 8px;
}
.deduction{
  font-size: 24px;
  color: #9b9b9b;
  margin-bottom: 24px;
}
</style>
